// extracted by mini-css-extract-plugin
export default {"blockContainer":"Block_blockContainer__vj7Rz","blockTitle":"Block_blockTitle__ckGAU","blockComponent":"Block_blockComponent__LhEiA","noPadding":"Block_noPadding__aJzax"};